import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TabelaPrecoService {

  constructor(private httpClient: HttpClient) { }

  cadastrarTabelaPreco(json, justificativa = 'justificativa') {
    return this.httpClient.post(environment.wsUrl + 'tabelaPreco/criarTabelaPrecoConsulta', json, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  alterarTabelaPreco(json, justificativa = 'justificativa') {
    return this.httpClient.post(environment.wsUrl + 'tabelaPreco/atualizarTabelaPrecoConsulta', json, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  listarTabelaPreco(json, ignore = ['loading']) {
    return this.httpClient.post<{ total:number, lista: any[]}>(environment.wsUrl + 'tabelaPreco/listaTabelaPrecoConsulta', json, {
      headers: {},
    }).toPromise();
  }

  excluirTabelaPreco(tabelaPreco, justificativa) {
    return this.httpClient.post<{ total:number, lista: any[]}>(environment.wsUrl + 'tabelaPreco/deletarTabelaPreco', tabelaPreco, {
      headers: {justificativa: justificativa},
    }).toPromise();
  }

  getTabelaPreco(uuid) {
    return this.httpClient.get<any>(environment.wsUrl + 'tabelaPreco/getTabelaPrecoConsulta/'+ uuid, {
      headers: {},
    }).toPromise();
  }

  cadastrarTabelaPrecoLaudo(json, justificativa = 'justificativa') {
    return this.httpClient.post(environment.wsUrl + 'laudo/criarTabelaPrecoTipoLaudo', json, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  alterarTabelaPrecoLaudo(json, justificativa = 'justificativa') {
    return this.httpClient.post(environment.wsUrl + 'laudo/atualizarTabelaPrecoTipoLaudo', json, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  listarTabelaPrecoLaudo(json, ignore = ['loading']) {
    return this.httpClient.post<{ total:number, lista: any[]}>(environment.wsUrl + 'laudo/listaTabelaPrecoTipoLaudo', json, {
      headers: {},
    }).toPromise();
  }

  excluirTabelaPrecoLaudo(uuid, justificativa) {
    return this.httpClient.post<{ total:number, lista: any[]}>(environment.wsUrl + 'laudo/deletarTabelaPreco', uuid, {
      headers: {justificativa: justificativa},
    }).toPromise();
  }

  getTabelaPrecoLaudo(uuid) {
    return this.httpClient.get<any>(environment.wsUrl + 'laudo/getTabelaPrecoTipoLaudo/'+ uuid, {
      headers: {},
    }).toPromise();
  }

  getListaTipoLaudo() {
    return this.httpClient.get<any[]>(environment.wsUrl + 'laudo/getListaTipoLaudoNome', {
      headers: {},
    }).toPromise();
  }

  getListaTipoLaudoCombinado() {
    return this.httpClient.get<any[]>(environment.wsUrl + 'laudo/getListaLaudoCombinadoNome', {
      headers: {},
    }).toPromise();
  }

  getTabelaPadrao() {
    return this.httpClient.get<{uuid}>(environment.wsUrl + 'tabelaPreco/tabelaPrecoPadrao').toPromise();
  }


  getTabelaPadraoLaudo() {
    return this.httpClient.get<{id}>(environment.wsUrl + 'laudo/tabelaPrecoPadrao').toPromise();
  }

}
